<template>
  <!-- 通用奖项组件 -->
  <component :is="comp" :awardData="data"></component>
</template>

<script>
import CashPack from './CashPack';
import Entity from './Entity';
import Vip from './Vip';
import Missing from './Missing';
import Coupon from './Coupon';
import LalamoveCoupon from './LalamoveCoupon';
import LuckyPack from './LuckyPack';
import FuzzyCashPack from './FuzzyCashPack';
import LalamoveMissing from './LalamoveMissing';
import Coin from './Coin';
const AWARD_IMG = {
  MEMBER:
    'https://ops-img-static.huolala.cn/imgs/2021/161424176915542281713066.png',
  RED_PACKET:
    'https://ops-img-static.huolala.cn/imgs/2021/16142418958117451081185.png',
  CURRENCY:
    'https://ops-img-static.huolala.cn/imgs/2021/16142418958117451081185.png',
  COUPON: {
    // 折扣券
    DISCOUNT_BY_RATE:
      'https://ops-img-static.huolala.cn/imgs/2021/161717762441231375882772.png',
    // 立减券
    DISCOUNT_NO_CONDITION:
      'https://ops-img-static.huolala.cn/imgs/2021/161717747526226085212772.png',
    // 满减券
    DISCOUNT_WITH_CONDITION:
      'https://ops-img-static.huolala.cn/imgs/2021/161717762439616858628381.png'
  },
  ENTERPRISE_CREDIT:
    'https://ops-img-static.huolala.cn/imgs/2021/16209730926842304361514.png',
  REWARD_PACKAGE:
    'https://ops-img-static.huolala.cn/imgs/2021/161718965536506224289123.png',
  NULL:
    'https://ops-img-static.huolala.cn/imgs/2021/16142421391557855741230.png'
};

const AwardComponentsBook = {
  RED_PACKET: CashPack,
  CURRENCY: CashPack,
  ENTITY: Entity,
  MEMBER: Vip,
  NULL: Missing,
  COUPON: Coupon,
  OIL_COUPON: Entity,
  REWARD_PACKAGE: LuckyPack,
  FUZZY_RED_PACKET: FuzzyCashPack,
  ENTERPRISE_CREDIT: Coin
};
const LalamoveAwardComponentsBook = {
  RED_PACKET: CashPack,
  CURRENCY: CashPack,
  ENTITY: Entity,
  MEMBER: Vip,
  NULL: LalamoveMissing,
  COUPON: LalamoveCoupon,
  OIL_COUPON: Entity,
  REWARD_PACKAGE: LuckyPack,
  FUZZY_RED_PACKET: FuzzyCashPack,
  ENTERPRISE_CREDIT: Coin
};
export default {
  props: {
    awardData: {
      type: Object,
      required: true
    },
    // 指定奖项模板，没有指定则使用 rewardType 值对应模板
    tpl: {
      validator: function(value) {
        return (
          Object.keys(AwardComponentsBook).indexOf(value) !== -1 ||
          Object.keys(LalamoveAwardComponentsBook).indexOf(value) !== -1
        );
      }
    }
  },
  computed: {
    comp() {
      if (this.$uiTheme === 'lalamove') {
        return LalamoveAwardComponentsBook[
          this.tpl || this.awardData.rewardType
        ];
      }
      return AwardComponentsBook[this.tpl || this.awardData.rewardType];
    },
    awardImgsMap() {
      return AWARD_IMG;
    },
    data() {
      return {
        ...this.awardData,
        imgUrl:
          this.awardImgsMap[this.awardData.rewardType] ||
          this.awardData.url ||
          this.awardData.rewardUrl ||
          this.awardData.imgUrl ||
          (this.awardData.detail && this.awardData.detail.imgUrl)
      };
    }
  }
};
</script>
